import { render } from "./GmailMailSummary.vue?vue&type=template&id=58d68aa7"
import script from "./GmailMailSummary.vue?vue&type=script&lang=js"
export * from "./GmailMailSummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__